import BaseViewController from '../../common/services/base-view-controller';
import selectBlankBoundaries from '../../common/services/boundaries-helpers';


class BlankController extends BaseViewController {
    constructor($scope, $state, $rootScope, LoadedModel, MenuElements) {
        super($scope, $state, LoadedModel);
        this._$rootScope = $rootScope;
        this.viewKey = this.blankViewKey;

        this.model.showWidthInput = this.model.isUsedCustomWidth;

        // TODO find out how to deal with this hack
        if (!this.model.calculatedWidth) {
          this.model.calculatedWidth = 0;
        }
        if(this.model.isStepPassed('feasibility')) {
            this.updateCurrentView(this.calculateBoundaries());
        } else  if (this.model.isStepPassed('part')) {
            this._$state.go('feasibility');
        } else {
            this._$state.go('home');
        }


        const mex = this.model._unit.value === 'psi' ? this.model.convertMetricToPSI(this.model.mex) : this.model.mex;
        this.slidersOptions= {
            convex: {
                 options: {
                    showSelectionBar: true,
                    stepsArray: [
                       {value: 0, legend: 'Low'},
                       {value: 1},
                       {value: 2},
                       {value: 3, legend: 'High'}
                    ],
                    floor: 0,
                    ceil: 3,
                    step: 1,
                    showTicks: true,
                }
            }, smooth: {
                options: {
                    showSelectionBar: true,
                    stepsArray: [
                        {value: 0, legend: 'Low'},
                        {value: 1},
                        {value: 2},
                        {value: 3, legend: 'High'}
                    ],
                    floor: 0,
                    ceil: 3,
                    step: 1,
                    showTicks: true,
                }
            }, width: {
                options: {
                    showSelectionBar: true,
                    floor: 0,
                    ceil: 4,
                    step: 1,
                    showTicks: true,
                    showTicksValues: true,
                    stepsArray: [
                        {value: 0, legend: "0"},
                        {value: 1, legend: this.round(mex/4)},
                        {value: 2, legend: this.round(mex/4*2)},
                        {value: 3, legend: this.round(mex/4*3)},
                        {value: 4, legend: this.round(mex/1)}
                    ],
                }
            }
        };
        const currBlankValues = this.model.getCurrBlankValues();
        if(currBlankValues && currBlankValues.customWidth !== undefined) {
          this._masterBlankValues = currBlankValues;
        }
        MenuElements.updateActiveStates('blank', true);
    }



    sendModel() {
        this.requestInProgress = this.model.requestInProgress =true;
        const uniqParam = this.model.uuid();
        this.model.getProgress(uniqParam, 'blank', true);

        if (this.model.customWidth === undefined) {
          this.model.customWidth = 0;
        }

        this.model.sendData(this.viewKey, false, uniqParam).then((results) => {
            this.model.isUsedCustomWidth = true;
            this.model.generateExpTime();
            this.requestInProgress = this.model.requestInProgress = false;
            const res = results.toJSON();
            this.model.invalidateSnapshots('blank');
            _.extend(this.model, res);
            const useCustom = this.model.showWidthInput && this.model.isUsedCustomWidth;

            const dataFile = useCustom ? this.model.blankBoundaryModCustom: this.model.blankBoundaryMod;
            const width = useCustom ? 4 : this.model.width;
            this.model.calculatedWidth = this.model.customWidth;
            this._$rootScope.$broadcast('updateView', [[selectBlankBoundaries(dataFile, this.model.convex,  this.model.smooth, width), this.model.meshLL, this.model.maxDimensions], undefined, 'blank'])
            this._$scope.$broadcast('solverFinished', {step: 'blank'});
            this._masterBlankValues  = this.model.getCurrBlankValues();
        }, (error) => {
            this._$rootScope.$broadcast('showErrorDialog', {type: 'blank'});
            this.model.generateExpTime();
            this.requestInProgress = this.model.requestInProgress = false;
        });
    }

    isDataChanged() {
        this.model.dataBlankChanged = JSON.stringify(this._masterBlankValues) !== JSON.stringify(this.model.getCurrBlankValues());
        return this.model.dataBlankChanged;

    }

    round(value) {
        if (this.model._unit.value === 'psi') {
          return value.toFixed(1);
        } else {
          return value.toFixed(0)
        }

    }

    toggleWithInput() {
        this.model.showWidthInput = !this.model.showWidthInput;
        // if(!this.model.showWidthInput) {
        //     // this.model.isUsedCustomWidth = false;
        // } else if (this.model.showWidthInput && this.model.blankBoundaryModCustom) {
        //     // this.model.isUsedCustomWidth = true;
        // }
        this.model.updateBoundary();
        // this.updateCurrentView(this.calculateBoundaries());
    }

    canShowInput() {
        return this.model.showWidthInput;
    }

    blockToggleButton() {
        return false;
    }

    calculateBoundaries() {
        const useCustom = this.model.isUsedCustomWidth;
        const dataFile = useCustom ? this.model.blankBoundaryModCustom: this.model.blankBoundaryMod;
        const width = useCustom ? 4 : this.model.width;
        return [selectBlankBoundaries(dataFile, this.model.convex, this.model.smooth, width), this.model.meshLL, this.model.maxDimensions];
    }
}

BlankController.$inject = ['$scope', '$state', '$rootScope', 'LoadedModel', 'MenuElements'];

export default BlankController;



// WEBPACK FOOTER //
// ./client/app/components/blank/blank.controller.js